/* Shared behaviour for Ronine product cards: wishlist hearts, wishlist badge and Quick add. */
(function () {
  if (window.__rnCards) return;
  window.__rnCards = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'rn-wish';
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } },
    set: function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  };

  function paint(scope) {
    var saved = store.get();
    (scope || document).querySelectorAll('[data-rn-heart]').forEach(function (h) {
      var on = saved.indexOf(h.dataset.rnHeart) > -1;
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      h.textContent = on ? '♥' : '♡';
    });
  }

  function badge() {
    var n = store.get().length;
    document.querySelectorAll('[data-rn-wish-badge]').forEach(function (b) {
      b.textContent = n > 99 ? '99+' : String(n);
      b.hidden = n === 0;
    });
  }

  function changed() {
    paint();
    badge();
    document.dispatchEvent(new CustomEvent('rn:wish'));
  }

  var PH = 'rn-wish-ph';
  function phGet() { try { return JSON.parse(localStorage.getItem(PH) || '{}'); } catch (e) { return {}; } }
  function phSet(o) { try { localStorage.setItem(PH, JSON.stringify(o)); } catch (e) {} }

  window.rnCards = { phGet: phGet, paint: paint, badge: badge, get: store.get, set: store.set, changed: changed };

  function init() { paint(); badge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paint(); badge(); } });

  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-rn-heart]');
    if (h) {
      var id = h.dataset.rnHeart, a = store.get(), i = a.indexOf(id), on = i === -1;
      if (on) a.push(id); else a.splice(i, 1);
      store.set(a);
      if (h.hasAttribute('data-rn-ph')) {
        var map = phGet();
        var card = h.closest('.rn-pc');
        if (on && card) map[id] = card.outerHTML.replace(/ aria-hidden="true"/, ''); else delete map[id];
        phSet(map);
      }
      changed();
      return;
    }
    var b = e.target.closest('[data-rn-qa]');
    if (b && !b.disabled) {
      var label = b.textContent;
      b.disabled = true;
      b.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(b.dataset.rnQa), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.rn-bagbtn').forEach(function (x) { x.textContent = 'Bag · ' + cart.item_count; });
          b.textContent = 'Added ✓';
        })
        .catch(function () { b.textContent = 'Try again'; })
        .then(function () { setTimeout(function () { b.textContent = label; b.disabled = false; }, 1600); });
    }
  });
})();
